import { colors } from "../../theme/colors";
import { MOBILE_NAV_MEDIA } from "../layout/layoutConstants";

export const MOBILE_NAV_MQ = `@media ${MOBILE_NAV_MEDIA}`;

export const SETTINGS_DRAWER_WIDTH = "650px";

export const SETTINGS_DRAWER_TRANSITION = {
    x: {
        duration: 0.18,
        ease: [0.22, 1, 0.36, 1],
    },
};

export const SETTINGS_DRAWER_BACKDROP_TRANSITION = {
    opacity: {
        duration: 0.16,
        ease: [0.22, 1, 0.36, 1],
    },
    backdropFilter: {
        duration: 0.16,
        ease: [0.22, 1, 0.36, 1],
    },
};

export const SETTINGS_DRAWER_SHELL_SX = {
    position: "fixed",
    top: 0,
    bottom: 0,
    right: 0,
    width: SETTINGS_DRAWER_WIDTH,
    maxWidth: SETTINGS_DRAWER_WIDTH,
    [MOBILE_NAV_MQ]: {
        width: "100%",
        maxWidth: "100%",
    },
    overflow: "hidden",
    boxSizing: "border-box",
    zIndex: 1401,
    display: "flex",
    flexDirection: "column",
};

export const SETTINGS_PANEL_SX = {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    width: "100%",
    minWidth: 0,
    minHeight: 0,
    overflow: "hidden",
    position: "relative",
    background: `
        linear-gradient(
            180deg,
            rgba(12,12,14,0.98) 0%,
            rgba(8,8,10,0.995) 100%
        )
    `,
    borderLeft: "1px solid rgba(255,255,255,0.06)",
    boxShadow:
        "-18px 0 40px rgba(0,0,0,0.45), inset 0 1px 0 rgba(255,255,255,0.04)",
    backdropFilter: "blur(18px)",
    WebkitBackdropFilter: "blur(18px)",
};

export const SETTINGS_PANEL_HAIRLINE_SX = {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: "2px",
    background:
        "linear-gradient(90deg, transparent, rgba(255,190,90,0.5), transparent)",
    pointerEvents: "none",
    zIndex: 3,
};

export const SETTINGS_TAB_ROW_SX = {
    display: "flex",
    flexDirection: "row",
    alignItems: "stretch",
    justifyContent: "flex-start",
    flex: "0 0 auto",
    width: "100%",
    minWidth: 0,
    gap: "0.75rem",
    px: 0,
    borderBottom: "1px solid rgba(255,255,255,0.06)",
    [MOBILE_NAV_MQ]: {
        gap: "0.35rem",
        flexWrap: "nowrap",
    },
};

export const SETTINGS_PANEL_BODY_SX = {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: 0,
    overflow: "auto",
    width: "100%",
    pt: "1.25rem",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
        display: "none",
        width: 0,
        height: 0,
    },
    [MOBILE_NAV_MQ]: {
        pt: "0.95rem",
    },
};

export const SETTINGS_CONTENT_COLUMN_SX = {
    width: "100%",
    px: "1.5rem",
    boxSizing: "border-box",
    [MOBILE_NAV_MQ]: {
        px: "0.95rem",
    },
};

export const SETTINGS_PANEL_FOOTER_SX = {
    flexShrink: 0,
    width: "100%",
    ...SETTINGS_CONTENT_COLUMN_SX,
    py: "0.95rem",
    pb: "calc(0.95rem + env(safe-area-inset-bottom, 0px))",
    borderTop: "1px solid rgba(255,255,255,0.06)",
    background: `
        linear-gradient(
            180deg,
            rgba(10,10,12,0.92) 0%,
            rgba(8,8,10,0.98) 100%
        )
    `,
    [MOBILE_NAV_MQ]: {
        ...SETTINGS_CONTENT_COLUMN_SX[MOBILE_NAV_MQ],
        py: "0.8rem",
        pb: "calc(0.8rem + env(safe-area-inset-bottom, 0px))",
    },
};

export const SETTINGS_SECTION_PAD_SX = {
    py: "1.35rem",
    [MOBILE_NAV_MQ]: {
        py: "0.9rem",
    },
};

export const SETTINGS_FULL_DIVIDER_SX = {
    ...SETTINGS_CONTENT_COLUMN_SX,
    flexShrink: 0,
    "&::after": {
        content: '""',
        display: "block",
        width: "100%",
        borderBottom: "1px solid rgba(255,255,255,0.06)",
    },
};

export const SETTINGS_SECTION_HEADER_SX = {
    display: "flex",
    flexDirection: "column",
    gap: "0.25rem",
    minWidth: 0,
    [MOBILE_NAV_MQ]: {
        gap: "0.12rem",
    },
};

export const SETTINGS_SECTION_TITLE_SX = {
    fontSize: "0.8rem",
    fontWeight: 800,
    letterSpacing: "0.16em",
    textTransform: "uppercase",
    color: colors.text.primary,
    lineHeight: 1,
    [MOBILE_NAV_MQ]: {
        fontSize: "0.72rem",
        letterSpacing: "0.12em",
        lineHeight: 1.2,
    },
};

export const SETTINGS_SECTION_DESC_SX = {
    fontSize: "0.725rem",
    fontWeight: 500,
    letterSpacing: "0.04em",
    color: "rgba(255,255,255,0.42)",
    [MOBILE_NAV_MQ]: {
        fontSize: "0.68rem",
        lineHeight: 1.35,
    },
};

export const SETTINGS_SECTION_BODY_SX = {
    display: "flex",
    flexDirection: "column",
    mt: "1.25rem",
    [MOBILE_NAV_MQ]: {
        mt: "0.85rem",
    },
};
